type CardType = 'credit' | 'debit';
type CardBrand = keyof typeof CARD_GRADIENTS.credit;
type CardIconBrand = CardBrand | '';

const CARD_GRADIENTS = {
  credit: {
    mastercard: 'bg-gradient-to-r from-[#B153D7] to-[#4D2FB2]',
    visa: 'bg-gradient-to-r from-[#E6008D] to-[#F70022]',
    amex: 'bg-gradient-to-r from-[#3302BB] to-[#D103AE]',
  },
  debit: {
    mastercard: 'bg-gradient-to-r from-[#FE7F2D] to-[#FF4646]',
    visa: 'bg-gradient-to-r from-[#59CED9] to-[#209CAE]',
    amex: 'bg-gradient-to-r from-[#29BEF3] to-[#854FF6]',
  },
} as const;

function normalizeCardBrand(brand: string): CardIconBrand {
  const normalized = brand.toLowerCase().replace(/[\s_-]/g, '');
  if (normalized === 'visa') return 'visa';
  if (normalized === 'amex' || normalized === 'americanexpress') return 'amex';
  if (normalized === 'mastercard' || normalized === 'mc') return 'mastercard';
  return '';
}

function getCardBrandLabel(brand: string): string {
  return normalizeCardBrand(brand) === 'amex' ? 'American Express' : brand;
}

function getCardGradient(cardType: CardType, brand: string): string {
  const gradientBrand = normalizeCardBrand(brand) || 'mastercard';
  return CARD_GRADIENTS[cardType][gradientBrand];
}

export { getCardBrandLabel, getCardGradient, normalizeCardBrand };
